import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { selectLegacyBaseUrl } from '~/store';
import { routerLocationShape, routerMatchShape } from '../helpers/propTypeShapes';
import '../style/admin.css';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleMessageEvent = this.handleMessageEvent.bind(this);
  }

  componentDidMount() {
    const { location, checkAuthorization } = this.props;
    if (typeof location !== 'undefined' && checkAuthorization) {
      checkAuthorization(location.pathname, encodeURIComponent(location.search));
    }

    window.addEventListener('message', this.handleMessageEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessageEvent);
  }

  handleMessageEvent(event) {
    const { location, reAuth, trackEvent } = this.props;

    if (event.data.message === 'authUnauthorized') {
      trackEvent('401', {
        source: event.data.value,
      });
      // eslint-disable-next-line no-console
      console.error('Received 401 response from message event listener (Admin). Redirecting to login.');
      reAuth(location.pathname, encodeURIComponent(location.search));
    }
  }

  render() {
    let source = '';
    let className = '';
    let markup = null;

    if (typeof this.props !== 'undefined' && typeof this.props.iframeSrc !== 'undefined') {
      sessionStorage.removeItem('currentChannelToken');
      sessionStorage.removeItem('currentBroadcastId');
      sessionStorage.removeItem('currentBroadcastHash');
      source = this.props.iframeSrc;
      className = 'iframe-content';
    } else if (
      typeof this.props.location.state !== 'undefined' &&
      typeof this.props.location.state.iframeSrc !== 'undefined'
    ) {
      source = this.props.location.state.iframeSrc;
      className = 'iframe-content-fullscreen';
    } else if (this.props.match.params.pageName === 'comments') {
      const params = new URLSearchParams(this.props.location.search);
      if (params.get('channel') !== null) {
        sessionStorage.setItem('currentChannelToken', params.get('channel'));
        sessionStorage.setItem('currentBroadcastId', params.get('id'));
        sessionStorage.setItem('currentBroadcastHash', params.get('hash'));
      }

      source = `${this.props.legacyBaseUrl}/comments/index.php`;
      className = 'iframe-content-fullscreen';
    }
    if (!source || source.charAt(0) === '/') {
      markup = <div />;
    } else {
      markup = <iframe id="adminIframe" className={className} src={source} title="portal-container" />;
    }
    return markup;
  }
}

const mapStateToProps = (state) => ({ legacyBaseUrl: selectLegacyBaseUrl(state) });
const mapDispatchToProps = {};

Admin.defaultProps = {
  checkAuthorization: undefined,
  iframeSrc: undefined,
};

Admin.propTypes = {
  checkAuthorization: PropTypes.func,
  iframeSrc: PropTypes.string,
  location: routerLocationShape.isRequired,
  match: routerMatchShape.isRequired,
  reAuth: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  legacyBaseUrl: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));
